"use strict";

var util = require('../../util/property-util');
var arrayUtil = require('../../util/array-util');
var nocUtil = require('../../util/noc-util');

module.exports = /*@ngInject*/ ["$scope", "$rootScope", "$filter", "UrlRoutingFactory", "trains", "words", "$state", "AdvancedQueryResourceService", "TrainCacheService", "TrainTypeService", "TrainMaintainerService", "TripDashboardStatus", "ExportResourceService", "CsvFactory", "TimeZoneFactory", "LocaleFactory", function ($scope, $rootScope, $filter, UrlRoutingFactory, trains, words, $state, AdvancedQueryResourceService,
                                         TrainCacheService, TrainTypeService, TrainMaintainerService, TripDashboardStatus, ExportResourceService, CsvFactory, TimeZoneFactory, LocaleFactory) {

    $scope.maxToDateTime = new Date()
    $scope.TripDashboardStatus = TripDashboardStatus;
    $scope.status = TripDashboardStatus.NO_STATUS;

    $scope.query = {};
    $scope.query.trains = {};
    $scope.queryError = "";
    $scope.trains = arrayUtil.sortByOfficialId(trains);

    $scope.tripsDashboard = "no search yet";

    $scope.words = {};

    function initPage() {
        var from = UrlRoutingFactory.getTimestamp("from");
        var to = UrlRoutingFactory.getTimestamp("to");

        $scope.words = words;
        $scope.query.query = UrlRoutingFactory.get("query");

        $scope.requireGoodTrips = nocUtil.parseStringToBoolean(UrlRoutingFactory.get("goodtrips"));

        if (!util.isDefined(from) || !util.isDefined(to)) {
            // if either from or to is not defined, choose default period of 1 day
            lastDays(1);
        } else {
            $scope.query.from = nocUtil.toDate(from);
            $scope.query.to = nocUtil.toDate(to);
        }

        if (!util.isDefined($scope.requireGoodTrips)) {
            $scope.requireGoodTrips = true;
        }

        var selectedTrainIds = UrlRoutingFactory.get("trainIds", true);
        TrainCacheService.setManually($scope.trains);

        // get the train types from the trains.
        $scope.trainTypeObjects = TrainTypeService.getTrainTypeObjects($scope.trains);

        $scope.customTrainTypeNames = TrainTypeService.getTrainTypeDisplayNameObjects($scope.trains);

        // get the selectedTrainTypes.
        var selectedTrainTypes = UrlRoutingFactory.get("trainTypes", true);

        // keeps track of selected trainTypes
        $scope.query.trainTypeData = [];

        // restore previous selected train types.
        if (util.isDefined(selectedTrainTypes)) {
            selectedTrainTypes.forEach(function (trainType) {
                // for every trainType String, look in trainTypes if it has a matching record.
                $scope.trainTypeObjects.some(function (trainTypeData) {
                    // should be done by reference: that's why we do it in such a stupid way :/
                    if (trainTypeData.code == trainType) {
                        $scope.query.trainTypeData.push(trainTypeData);
                        return true;
                    }

                    return false;
                });
            })
        }


        // get the train maintainers from the trains.
        $scope.trainMaintainerObjects = TrainMaintainerService.getTrainMaintainerObjects($scope.trains);

        // get the selectedMaintainers.
        var selectedTrainMaintainers = UrlRoutingFactory.get("trainMaintainers", true);

        // keeps track of selected trainMaintainers
        $scope.query.trainMaintainerData = [];

        // restore previous selected train maintainer.
        if (util.isDefined(selectedTrainMaintainers)) {
            selectedTrainMaintainers.forEach(function (trainMaintainer) {
                // for every trainMaintainer String, look in trainMaintainers if it has a matching record.
                $scope.trainMaintainerObjects.some(function (trainMaintainerData) {
                    // should be done by reference: that's why we do it in such a stupid way :/
                    if (trainMaintainerData.code === trainMaintainer) {
                        $scope.query.trainMaintainerData.push(trainMaintainerData);
                        return true;
                    }

                    return false;
                });
            })
        }

        $scope.query.trains = [];
        if (util.isDefined(selectedTrainIds)) {
            selectedTrainIds.forEach(function (trainId) {
                // important: the selected item must be a reference to an item from the model that is displayed in the view
                // containing the same data is not enough (for it to appear selected in the view)
                var foundTrain = TrainCacheService.getRelativeTrain(trainId);
                if (util.isDefined(foundTrain)) {
                    $scope.query.trains.push(foundTrain);
                }
            });
        }
    }

    initProject();
    initPage();

    $scope.exportToCsv = function () {
        ExportResourceService.exportTrips().query(getSearchParams()).$promise.then(function (data) {

            if (util.isDefined(data) && !arrayUtil.isNotEmptyArray(data)) {
                console.warn("No trips found for this criteria");
                return;
            }

            var separator = LocaleFactory.getCurrentLocaleConfig().separator;

            var csvString = "";
            csvString += "Trip id" + separator;
            csvString += "Train id" + separator;
            csvString += "Official id" + separator;
            csvString += "Start" + separator;
            csvString += "End" + separator;
            csvString += "Departure" + separator;
            csvString += "Arrival" + separator;
            csvString += "Duration (s)" + separator;
            csvString += "Main trip" + separator;

            csvString += "\n";
            data.forEach(function (jsonObject) {
                csvString += jsonObject.id + separator;
                csvString += jsonObject.trainId + separator;
                csvString += jsonObject.officialId + separator;
                csvString += jsonObject.departureStation + separator;
                csvString += jsonObject.arrivalStation + separator;
                csvString += TimeZoneFactory.dateInCurrentTimeZone(jsonObject.departure).format() + separator;
                csvString += TimeZoneFactory.dateInCurrentTimeZone(jsonObject.arrival).format() + separator;
                csvString += (jsonObject.arrival - jsonObject.departure) / 1000 + separator;
                csvString += jsonObject.mainTrainTrip + separator;
                csvString += "\n";
            });

            CsvFactory.download(csvString);
        });
    };


    $scope.$on('tripDashboardStatusChange', function (event, data) {
        //console.log(data);
        $scope.status = data;
    });


    $scope.from = function () {
        if (angular.isDefined($scope.query.from)) {
            return $filter('date')($scope.query.from, 'dd-MM-yyyy-HH:mm');
        } else {
            return "";
        }
    };

    $scope.to = function () {
        if (angular.isDefined($scope.query.to)) {
            return $filter('date')($scope.query.to, 'dd-MM-yyyy-HH:mm');
        } else {
            return "";
        }
    };

    $scope.noTrainsSelected = function () {
        return $scope.query.trains == undefined || $scope.query.trains.length == 0;
    };

    $scope.getTrainIds = function () {
        if ($scope.noTrainsSelected()) {
            return "";
        }
        return util.getListOfProperties($scope.query.trains, 'id');
    };


    function getDefaultSelectedProject() {
        var projectId = $rootScope.selectedProject;
        if (!angular.isDefined(projectId)) {
            projectId = -1;
        } else {
            projectId = projectId.id;
        }
        return projectId;
    }

    /**
     * Filter, called for every train and decides if the train should be shown according to trainTypes array.
     *
     * @param trainTypeObjects
     * @param trainMaintainerObjects
     * @returns {Function}
     */
    $scope.filterTrains = function (trainTypeObjects, trainMaintainerObjects) {
        return function (train) {
            return TrainTypeService.filterTrainByTypesFilter(train, trainTypeObjects) &&
                TrainMaintainerService.filterTrainByMaintainersFilter(train, trainMaintainerObjects);
        };
    };


    /**
     * clear the selected trains by setting the length to 0.
     * @param selectedTrains
     */
    $scope.clearTrains = function (selectedTrains) {
        if (util.isDefined(selectedTrains) && angular.isArray(selectedTrains)) {
            selectedTrains.length = 0;
        }
    };


    $scope.dateOptions = {
        'year-format': "'yyyy'",
        'starting-day': 1
    };

    $scope.openFrom = function ($event) {
        $scope.openedTo = false;
        $event.preventDefault();
        $event.stopPropagation();
        $scope.openedFrom = true;
    };

    $scope.openTo = function ($event) {
        $scope.openedFrom = false;
        $event.preventDefault();
        $event.stopPropagation();
        $scope.openedTo = true;
    };

    $scope.lastDays = function (days) {
        lastDays(days);
    };

    function lastDays(days) {
        var period = nocUtil.createPeriodUpToNow(days);
        $scope.query.to = period.end;
        $scope.query.from = period.start;
    }

    $scope.skipFromDays = function (days) {
        $scope.query.from = new Date($scope.query.from.getTime() + ((days * 24 * 60 * 60 * 1000)));
    };

    $scope.skipToDays = function (days) {
        $scope.query.to = new Date($scope.query.to.getTime() + ((days * 24 * 60 * 60 * 1000)));
    };

    function getSearchParams() {
        var query = $scope.query.query;
        var trainIds = $scope.getTrainIds().join(',');

        var tzPeriod = TimeZoneFactory.formatPeriodInCurrentTimezone($scope.query.from, $scope.query.to);

        if (!util.isDefined(query)) {
            query = "";
        }
        else if(query === "" && $scope.requireGoodTrips){
             query = "LATENCY > -1";
        }
        else if(util.isDefined(query) && $scope.requireGoodTrips) {
            query = query.concat("AND LATENCY > -1");
        }

        return {
            projectId: $scope.selectedProject.id,
            trainIds: trainIds,
            // from: from,
            // to: to,
            from: tzPeriod.start,
            to: tzPeriod.end,
            type: "main",
            query: query
        };
    }

    $scope.findTripsForDashboard = findTripsForDashboard;
    
    function findTripsForDashboard(skipSave) {
        $scope.status = $scope.TripDashboardStatus.SEARCHING_TRIPS;

        if (!skipSave) {
            UrlRoutingFactory.saveTimestamp("from", $scope.query.from);
            UrlRoutingFactory.saveTimestamp("to", $scope.query.to);
            UrlRoutingFactory.saveListOfProperties("trainIds", $scope.query.trains, "relativeId");
            UrlRoutingFactory.saveListOfProperties("trainTypes", $scope.query.trainTypeData, "code");
            UrlRoutingFactory.saveListOfProperties("trainMaintainers", $scope.query.trainMaintainerData, "code");
            UrlRoutingFactory.save("query", $scope.query.query);
            UrlRoutingFactory.save("main", true);
            UrlRoutingFactory.save("goodtrips", $scope.requireGoodTrips);
        }

        var searchParams = getSearchParams();

        AdvancedQueryResourceService.tripsDashboard().get(searchParams).$promise.then(function (data) {

            if (util.isDefined(data) && !arrayUtil.isNotEmptyArray(data.tripIds)) {
                console.warn("No trip ids found for this criteria");
                $scope.emptyResult = true;
                $scope.status = $scope.TripDashboardStatus.NO_TRIPS_FOUND;
                return;
            }

            $scope.status = $scope.TripDashboardStatus.SEARCHING_TRIP_DATA;


            var params = {
                'query': searchParams.query,
                'trainIds': searchParams.trainIds,
                'projectId': $scope.selectedProject.id,
                'from': $scope.query.from,
                'to': $scope.query.to,
                'type': searchParams.type
            };

            $state.go('trip-dashboard.sla', params, {location: false, inherit: false, reload: true});
        });
    };


    $scope.updatedProjectListener = $rootScope.$on('menu-changed-project', function (event, name) {
        initProject();
    });

    $scope.$on('$destroy', function () {
        $scope.updatedProjectListener();
    });

    function initProject() {
        var selectedProject = $rootScope.selectedProject;
        // possible that selected project is not allowed to be shown.
        if (angular.isDefined(selectedProject)) {
            $scope.selectedProject = selectedProject;
            $scope.query.trains = undefined;
        }
    }

    $scope.executeQuery = function () {
        findTripsForDashboard(false);
    };

    $scope.onFromDateChange = (date) => {
        $scope.query.from = date;
        $scope.$apply()
        $scope.$digest()
    }

    $scope.onToDateChange = (date) => {
        $scope.query.to = date;
        $scope.$apply()
        $scope.$digest()
    }
}];

